import React, { Fragment } from 'react'

import { ErrorBoundary } from 'helpers'
import { Caption } from 'ui/bend/typography'
import Disclaimer from 'ui/acro/blocks/Disclaimers/Disclaimer'

const SubscriptionDisclaimer = ({
  cta = 'Start Trial',
  disclaimer,
  hideTerms = false,
  isSignupScreen = true,
  hideSignInDisclimer = false,
  passcodeAvailable = false,
  aloWellnessTerm = false,
  passcodeLabel = '',
  ...rest
}) => {
  return (
    <Fragment>
      <Caption as='div' color='#3B3B3B' {...rest}>
        {disclaimer && <Fragment>{disclaimer}&nbsp;</Fragment>}
        {!hideTerms && (
          <Disclaimer
            reactivate={rest.reactivate}
            hideSignInDisclimer={hideSignInDisclimer}
            actionText={cta}
            isSignupScreen={isSignupScreen}
            passcodeAvailable={passcodeAvailable}
            aloWellnessTerm={aloWellnessTerm}
            passcodeLabel={passcodeLabel}
            Wrapper='span'
          />
        )}
      </Caption>
    </Fragment>
  )
}

const SafeSubscriptionDisclaimer = (props) => (
  <ErrorBoundary>
    <SubscriptionDisclaimer {...props} />
  </ErrorBoundary>
)

export default SafeSubscriptionDisclaimer
